import React, {useState} from 'react';
//import { GoogleReCaptcha, GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import base64 from 'base-64';
import ReCaptcha from "@pittica/gatsby-plugin-recaptcha"

const Recaptcha = ({ action, onVerify, id }) => {
  const RECAPTCHA_SITE_KEY = process.env.GATSBY_RECAPTCHA_PUBLIC_KEY;
  const username = process.env.GATSBY_BASIC_AUTH_USERNAME
  const password = process.env.GATSBY_BASIC_AUTH_PASSWORD
  const [submitted, setSubmitted] = useState(false)

  const handleVerify = async (token) => {
    const response = await fetch(`${process.env.GATSBY_DRUPAL_API_URL}/recaptcha`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + base64.encode(username + ":" + password)
      },
      body: JSON.stringify({
        action,
        token,
      }),
    });
    const data = await response.json();
    onVerify(data?.success);
  };

  return (
    <ReCaptcha
        useRecaptchaNet
        scriptProps={{ async: true, defer: true, appendTo: 'body' }}
        action={action}
        siteKey={RECAPTCHA_SITE_KEY}
        onVerify={(token) => handleVerify(token)}
        submitted={submitted}
        id={id+Math.random()}
        badge={"bottomright"}
        size={"invisible"}
    />
  );
};

export default Recaptcha;
